import React, {Component} from 'react';
import {injectIntl, intlShape} from 'react-intl';

import {sendToParent, TYPES} from '../../common/events';
import AppBlock from '../components/AppBlock';
import Title from '../components/Form/Title';

const clickEventListener = function(event) {
  if (event.target.nodeName.toUpperCase() === 'BODY') {
    sendToParent(TYPES.HIDE_POPUP);
  }
};

class Page500 extends Component {
  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    if (window.self === window.top) {
      document.body.className += ' with-bg';
    }
    document.addEventListener('click', clickEventListener);
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    document.removeEventListener('click', clickEventListener);
  }

  render() {
    const {messages} = this.props.intl;

    return (
      <div className="content">
        <div className="wrapper">
          <AppBlock>
            <Title title={messages['page500.title']} titleClassName="title--error" />

            <div className="block-content block-content--horizontal-center">
              {messages['page500.text']}
            </div>
          </AppBlock>
        </div>
      </div>
    );
  }
}

Page500.propTypes = {
  intl: intlShape
};

export default injectIntl(Page500);



// WEBPACK FOOTER //
// ./pages/500.jsx